module.exports = "<div class=\"site-container\" [ngClass]=\"{'rtl': rtl}\" [attr.dir]=\"rtl ? 'rtl' : null\">\r\n  <main class=\"main-content\">\r\n    <div class=\"main-content-wrap\">\r\n      <router-outlet></router-outlet>\r\n    </div>\r\n  </main>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/layouts/extra/extra.component.html
// module id = ../../../../../src/app/layouts/extra/extra.component.html
// module chunks = 39